class ApiHelper {
  checkParameters (params, rules) {

  }

  prepareParameters (params, rules) {
    return new Promise((resolve, reject) => {
      resolve()
      // reject(new Error('test error'))
    })
  }
}

export default new ApiHelper()
